import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NotificationService} from '@enerbim/commons-lib';
import {environment} from '../../../environments/environment';

class FileDownload {
    constructor(public url: string) {
    }
}

@Injectable({
    providedIn: 'root'
})

export class FileService {

    constructor(private http: HttpClient,
                private notificationService: NotificationService) {
    }

    download(id: string, idElement?: string, callback?: Function): void {
        // Récupère le token
        let fileDownloadTokenUrl = `${environment.apiUrl}/fs/fichiers/${id}/get-download-token`;
        if (idElement) {
            fileDownloadTokenUrl += `?idElement=${idElement}`;
        }
        this.http.get<FileDownload>(fileDownloadTokenUrl).subscribe(
            f => {
                // Crée un lien virtuel pour pouvoir télécharger le fichier (et éviter le soucis avec le JWT)
                const anchor = document.createElement('a');
                anchor.href = `${environment.apiUrl}${f.url}`;
                const event = document.createEvent('MouseEvents');
                event.initMouseEvent(
                    'click', true, false, window, 0, 0, 0, 0, 0
                    , false, false, false, false, 0, null
                );
                anchor.dispatchEvent(event);
                anchor.remove();
                if (callback) {
                    callback();
                }
            },
            error => {
                if (error.status === 404) {
                    this.notificationService.error('Le fichier n\'a pas pu être trouvé. Merci de contacter le support.');
                } else {
                    this.notificationService.error('Une erreur inconnue s\'est produite. Merci de contacter le support.');
                }
                if (callback) {
                    callback();
                }
            });

    }
}
